import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=7c6c70a0&scoped=true"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"
import style0 from "./Standard.vue?vue&type=style&index=0&id=7c6c70a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c70a0",
  null
  
)

export default component.exports